export default function getDefaultDeviceThemeOptions () {
    return {
      dataLabels: {
        dropShadow: {
          enabled: false,
        },
      },
        labels: ['Mobile', 'Desktop', 'Tablet'],
        responsive: [
            {
                breakpoint: 480,
                options: {
                    chart: {
                        width: '100%',
                    },
                    legend: {
                        position: 'left',
                    },
                },
            },
        ],
        // Positionally maps to series order enforced in processChartData:
        // Mobile, Desktop, Tablet.
        colors: [
            '#0078FF',
            '#FF4D00',
            '#FF9E00',
        ],
        states: {
          normal: {
              filter: {
                  type: 'none',
                  value: 0,
              },
          },
          hover: {
              filter: {
                  type: 'none',
                  value: 0,
              },
          },
          active: {
              allowMultipleDataPointsSelection: false,
              filter: {
                  type: 'none',
                  value: 0,
              },
          },
        },
    };
};
